import { AxiosService } from './';

const getConfigurationDetails = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'admin/configuration',
      isAuthorized: true,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};
const update = async (_formData) => {
  try {
    let axiosData = {
      method: 'put',
      url: 'admin/configuration',
      isAuthorized: true,
      formData: _formData,
    };
    const response = await AxiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    throw Error(error.message);
  }
};

export { getConfigurationDetails, update };
